import { jsx as _jsx } from "react/jsx-runtime";
import noop from 'lodash/noop';
import { createContext, useContext } from 'react';
import { useSchedules } from './utils/useSchedules';
/** The context. */
export const OpeningHoursContext = createContext({
    hasNextPage: false,
    hasPreviousPage: false,
    isLoading: false,
    schedules: [],
    schedulesInConflicts: [],
    totalNumberOfSchedules: 0,
    nextPage: noop,
    previousPage: noop,
    refetchItems: noop,
    refetchSchedulesInConflicts: noop,
});
/** The context provider. All its children will have access to its value. */
export const OpeningHoursProvider = ({ children, }) => {
    const { asyncStatus, currentPageSchedules, hasNextPage, hasPreviousPage, schedulesInConflicts, totalNumberOfSchedules, nextPage, previousPage, refetchItems, refetchSchedulesInConflicts, } = useSchedules();
    return (_jsx(OpeningHoursContext.Provider, Object.assign({ value: {
            hasNextPage,
            hasPreviousPage,
            isLoading: asyncStatus === 'pending',
            schedules: currentPageSchedules,
            schedulesInConflicts,
            totalNumberOfSchedules,
            nextPage,
            previousPage,
            refetchItems,
            refetchSchedulesInConflicts,
        } }, { children: children })));
};
/** A hook exposing the context functionality. */
export const useOpeningHoursContext = () => {
    const context = useContext(OpeningHoursContext);
    if (!context) {
        throw new Error('Missing OpeningHoursContext');
    }
    return context;
};
